export function getReferenceName(name) {
    const regex2 = /[^A-Za-z0-9_]/ig;
    return name.replaceAll(regex2, '_');
}